import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import { getMipsData } from './mips.service'
import { fetchMipsReportError, fetchMipsReportSuccess } from './mips.actions'
const { FETCH_MIPS_REPORT } = require('./mips.types')

const fetchMipsReportEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_MIPS_REPORT),
    switchMap((action) =>
      from(getMipsData(action.payload)).pipe(
        switchMap((response) => of(fetchMipsReportSuccess(response))),
        catchError((error) =>
          of(fetchMipsReportError(error?.message || 'API Error')),
        ),
      ),
    ),
  )

export default {
  fetchMipsReportEpic,
}
